import type { BrandCollectionState, BrandList } from "src/api/client-api/brand/useGetAllBrand";

type BrandQuery = {
    brandCollectionState: BrandCollectionState;
    refetch: () => void | Promise<unknown>;
};

type GetActiveBrandCollectionOptions = {
    isSearchActive: boolean;
    listQuery: BrandQuery;
    searchQuery: BrandQuery;
};

export const getActiveBrandCollection = (options: GetActiveBrandCollectionOptions) => {
    const query = options.isSearchActive ? options.searchQuery : options.listQuery;
    const { brandCollectionState: state } = query;
    const hasCollection = state.status === "success-value" || state.status === "empty";

    return {
        state,
        items: hasCollection ? state.items : undefined,
        totalItems: hasCollection ? state.totalItems : undefined,
        refetch: query.refetch,
    } as {
        state: BrandCollectionState;
        items: BrandList[] | undefined;
        totalItems: number | undefined;
        refetch: () => void | Promise<unknown>;
    };
};
